// extracted by mini-css-extract-plugin
export var active = "_l9-e";
export var blink = "_l9-f";
export var dropDownSelector = "_l9-5";
export var dropDownWrapper = "_l9-4";
export var fakeCursor = "_l9-d";
export var fontSizeButton = "_l9-7";
export var formQuillEditor = "_l9-0";
export var pressed = "_l9-g";
export var qlBlank = "_l9-1";
export var textFormattingToolbar = "_l9-2";
export var textFormattingToolbarClosed = "_l9-3";
export var textFormattingToolbarInline = "_l9-6";
export var textToolbarOption = "_l9-8";
export var toolbarCell = "_l9-a";
export var toolbarCellCollapsed = "_l9-b";
export var toolbarOptionHitArea = "_l9-c";
export var toolbarOverflow = "_l9-9";